import PageNotFound from "@/views/PageNotFound.vue";
import redirectToLogin from "@/router/middleware/redirectToLogin";
import Login from "@/views/Login.vue";
import hideError from "@/router/middleware/hideError";
import closeModals from "@/router/middleware/closeModals";
import resetFooterCounter from "@/router/middleware/resetFooterCounter";
import checkToken from "@/router/middleware/checkToken";
import Account from "@/views/Account.vue";
import Error from "@/views/Error.vue";
import Logout from "@/views/Logout.vue";
import OAuthCallback from "@/views/oauth/OAuthCallback.vue";
import OAuthSilentCallback from "@/views/oauth/OAuthSilentCallback.vue";

export default [
    {
        path: '/',
        name: 'Home',
        component: PageNotFound, // THIS IS ONLY A PLACEHOLDER
        meta: {
            middleware: [redirectToLogin],
        }
    },
    {
        path: '/login',
        name: 'Login',
        component: Login,
        meta: {
            middleware: [hideError, closeModals, resetFooterCounter],
        }
    },
    {
        path: '/account',
        name: 'Account',
        components: {
            default: Account,
            LeftSidebar: () => import('@/components/Sidebar.vue'),
        },
        meta: {
            middleware: [hideError, checkToken, closeModals, resetFooterCounter],
        }
    },
    {
        path: '/error',
        name: 'Error',
        components: {
            default: Error,
            LeftSidebar: () => import('@/components/Sidebar.vue'),
        },
        meta: {
            middleware: [hideError, closeModals, resetFooterCounter],
        }
    },
    {
        path: "/logout",
        name: 'Logout',
        component:  Logout,
        meta: {
            middleware: [hideError, closeModals, resetFooterCounter],
        }
    },
    {
        path: "/sso/oAuthCallback",
        name: 'OAuthCallback',
        component: OAuthCallback,
    },
    {
        path: "/sso/oAuthCallback/silent",
        name: 'OAuthSilentCallback',
        component: OAuthSilentCallback,
    },
    {
        path: "/:pathMatch(.*)*",
        name: "404",
        component:  PageNotFound,
        meta: {
            middleware: [hideError, closeModals, resetFooterCounter],
        }
    },
]
